import React, { createContext, useContext, useState, useEffect } from 'react';

// Mock FrappeProvider
export const FrappeProvider = ({ children }: { children: React.ReactNode }) => {
    return <>{children}</>;
};

// Mock useFrappeAuth
export const useFrappeAuth = () => {
    return {
        currentUser: 'Guest User',
        isValidating: false,
        isLoading: false,
        login: async () => Promise.resolve({ user: 'Guest User' }),
        logout: async () => Promise.resolve(),
        updateCurrentUser: async () => { },
        getUserCookie: () => 'Guest User',
    };
};

// Mock Data for specific API calls
const mockData: Record<string, any> = {
    'surgical_training.api.user.get_user_roles': {
        message: {
            roles: ['System Manager', 'Administrator', 'Doctor'],
            frappe_roles: ['System Manager']
        }
    },
    'surgical_training.api.session.get_sessions': {
        message: {
            message: 'Success',
            data: [
                {
                    name: 'SESS-2025-001',
                    title: '2025-05-15 Wildlife Simulation',
                    description: 'Demonstration of video playback and annotation using a copyright-free wildlife clip.',
                    session_date: '2025-05-15',
                    status: 'Active',
                    student_1_name: 'Dr. Strange',
                    student_2_name: 'Dr. House',
                    video_count: 1
                }
            ]
        }
    },
    'surgical_training.api.session_assignment.get_user_assigned_sessions': {
        message: {
            message: 'Success',
            data: [
                {
                    name: 'SESS-2025-001',
                    title: '2025-05-15 Wildlife Simulation',
                    description: 'Demonstration of video playback and annotation using a copyright-free wildlife clip.',
                    session_date: '2025-05-15',
                    status: 'Active',
                    student_1_name: 'Dr. Strange'
                }
            ]
        }
    },
    'surgical_training.api.session.get_session_details': {
        message: {
            message: 'Success',
            data: {
                session: {
                    name: 'SESS-2025-001',
                    title: 'Laparoscopic Cholecystectomy Training',
                    description: 'Surgical simulation session focusing on the critical view of safety.',
                    status: 'Active',
                    session_date: '2025-05-15',
                },
                videos: [
                    {
                        title: 'Procedure View',
                        url: './assets/wildlife.mp4',
                        duration: 30,
                        video_file: './assets/wildlife.mp4'
                    }
                ],
                comments: []
            }
        }
    }
};

// Mock useFrappeGetCall
export const useFrappeGetCall = (path: string, params?: any, key?: string | null, options?: any) => {
    const data = mockData[path] || { message: {} };

    return {
        data,
        error: null,
        isLoading: false,
        isValidating: false,
        mutate: async () => { },
    };
};

// Mock useFrappePostCall
export const useFrappePostCall = (path: string) => {
    return {
        call: async (payload?: any) => {
            console.log(`Mock Post Call to ${path}`, payload);
            return { message: 'Success' };
        },
        isMutating: false,
        error: null,
    };
};

export const useFrappeDeleteCall = (path: string) => {
    return {
        call: async () => { },
        isMutating: false,
        error: null
    }
}

export const useFrappeFileUpload = () => {
    return {
        upload: async (file: File) => {
            console.log('Mock uploading file:', file.name);
            return { message: 'Success', file_url: URL.createObjectURL(file) };
        },
        isUploading: false,
        error: null,
        reset: () => { }
    }
}
